import { Routes, Route, useLocation } from "react-router-dom";
import { useEffect } from "react";
import AboutPage from "../pages/About";
import GalleryPage from "../pages/Gallery";
import TestimonialsPage from "../pages/Testimonials";
import ContactPage from "../pages/Contact";
import HandSurgery from "../pages/HandSurgery";
import WristSurgery from "../pages/WristSurgery";
import PeripheralSurgery from "../pages/PeripheralSurgery";
import BranchialSurgery from "../pages/BranchialSurgery";
import HomePage from "../pages/Home";
import ServicesPage from "../pages/Services";
import EventsArticles from "../pages/EventsArticles";
import PrivacyPolicy from "../pages/PrivacyPolicy";
import TermsConditions from "../pages/TermsConditions";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo({ top: 0, behavior: "instant" }); }, [pathname]);
  return null;
}

export default function AppRoutes() {
  return (
    <>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/gallery" element={<GalleryPage />} />
        <Route path="/services" element={<ServicesPage />} />
        <Route path="/testimonials" element={<TestimonialsPage />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/events-articles" element={<EventsArticles />} />
        <Route path="/hand" element={<HandSurgery />} />
        <Route path="/wrist" element={<WristSurgery />} />
        <Route path="/peripheral" element={<PeripheralSurgery />} />
        <Route path="/branchial" element={<BranchialSurgery />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms" element={<TermsConditions />} />
      </Routes>
    </>
  );
}
